import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center text-white"
      style={{
        minHeight: "100vh",
        backgroundImage: `url("/assets/page-not-found.png")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        position: "relative",
      }}
    >
      {/* Overlay for better readability */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.6)",
        }}
      ></div>

      {/* Content */}
      <div style={{ position: "relative", zIndex: 2 }}>
        <h2 className="mb-2 ">Oops! Page Not Found</h2>
        <p className="mb-4">The page you are looking for does not exist.</p>
        <button
          className="btn btn-outline-light"
          onClick={() => navigate("/dashboard")}
        >
          Go to Dashboard Now
        </button>
      </div>
    </div>
  );
}

export default PageNotFound;
